// extracted by mini-css-extract-plugin
export default {"Header":"Tags_Header__OTAiM","ID":"Tags_ID__UwQSP","Title":"Tags_Title__Ou4nD","Item":"Tags_Item__28HmI","More":"Tags_More__go5ZM"};